/**
 * Certaine props sont specific à NextJs pour exprimer une erreur, une redirection.
 * Dans ce cas de figure, dès que l'on rencontre ce type de props, nous ne retournons
 * plus que uniquement cette props.
 */
export const isNextProps = (res: unknown) =>
  Object.prototype.hasOwnProperty.call(res, 'redirect') ||
  Object.prototype.hasOwnProperty.call(res, 'notFound');
